<template>
  <MultipleChoicesDropdown
    title="Product Type"
    :value="startup.product_type"
    :show-clear-all="false"
    :single-choice="false"
    :search-enabled="false"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import PRODUCT_TYPES from '@/services/product-types'

export default {
  computed: {
    choices: () => PRODUCT_TYPES,
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choices) {
      const attr = 'product_type'
      const value = choices.map((c) => c.value)
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
    },
  },
}
</script>
